










































import Vue from 'vue'

export default Vue.extend({
  name: 'home',

  data: () => {
    return {
      user: {
        email: '',
        password: ''
      }
    }
  },

  methods: {
    async anonymousLogin () {
      try {
        const { error } = await this.$auth.anonymousLogin()
        if (error) alert(error.message)
      } catch (err) {
        window.console.error(err)
      }
    },
    async emailLogin () {
      try {
        const { email, password } = this.user
        const { error } = await this.$auth.emailLogin(email, password)
        if (error) alert(error.message)
      } catch (err) {
        window.console.error(err)
      }
    }
  }
})
